import { VisualizationConfigs, VisualizationType } from '@ddv/models';
import { NewSettingsOverrides } from '@ddv/widgets';

export function applySettingsOverrides(
    visualizationConfigs: VisualizationConfigs[],
    overrides: NewSettingsOverrides | undefined,
): VisualizationConfigs[] {
    const defaultVisualizationType = overrides?.defaultVisualizationType;
    const defaultSlicer = overrides?.defaultSlicerForDefaultVisualization;

    if (!defaultVisualizationType && !defaultSlicer) {
        return visualizationConfigs;
    }

    const defaultVizType = getDefaultVisualizationType(defaultVisualizationType, visualizationConfigs);

    return visualizationConfigs.map((vc) => getUpdatedVisualizationConfig(vc, defaultVizType, defaultSlicer));
}

function getUpdatedVisualizationConfig(
    visualizationConfig: VisualizationConfigs,
    defaultVisualizationType: VisualizationType | undefined,
    defaultSlicer: string | undefined,
): VisualizationConfigs {
    const isDefault = defaultVisualizationType ?
        visualizationConfig.visualizationType === defaultVisualizationType :
        visualizationConfig.isDefault;

    if (visualizationConfig.visualizationType !== defaultVisualizationType || !defaultSlicer || !visualizationConfig.configs?.slicers) {
        return { ...visualizationConfig, isDefault };
    }

    return {
        ...visualizationConfig,
        isDefault,
        configs: {
            ...visualizationConfig.configs,
            slicers: visualizationConfig.configs.slicers.map((s) => ({ ...s, isDefault: s.value === defaultSlicer })),
        },
    };
}

function getDefaultVisualizationType(
    defaultVisualizationType: VisualizationType | undefined,
    visualizationConfigs: VisualizationConfigs[],
): VisualizationType | undefined {
    return defaultVisualizationType ??
        visualizationConfigs.find((vc) => vc.isDefault)?.visualizationType ??
        visualizationConfigs[0]?.visualizationType;
}
